/**
 * Generated flag codes and names
 * DO NOT EDIT - Generated by tools/texturepacker/flag-processor.ts
 */

/** Every flag the client has assets for: flag-icons' set and the custom five */
export const FLAG_CODES = [
  'ad',
  'ae',
  'af',
  'ag',
  'ai',
  'al',
  'am',
  'ao',
  'aq',
  'ar',
  'arab',
  'as',
  'asean',
  'at',
  'au',
  'aw',
  'ax',
  'az',
  'ba',
  'bb',
  'bd',
  'be',
  'bf',
  'bg',
  'bh',
  'bi',
  'bj',
  'bl',
  'bm',
  'bn',
  'bo',
  'bq',
  'br',
  'bs',
  'bt',
  'bv',
  'bw',
  'by',
  'bz',
  'ca',
  'cc',
  'cd',
  'cefta',
  'cf',
  'cg',
  'ch',
  'ci',
  'ck',
  'cl',
  'cm',
  'cn',
  'co',
  'communist',
  'confederate',
  'cp',
  'cr',
  'cu',
  'cv',
  'cw',
  'cx',
  'cy',
  'cz',
  'de',
  'dg',
  'dj',
  'dk',
  'dm',
  'do',
  'dz',
  'eac',
  'ec',
  'ee',
  'eg',
  'eh',
  'er',
  'es',
  'es-ct',
  'es-ga',
  'es-pv',
  'et',
  'eu',
  'fi',
  'fj',
  'fk',
  'fm',
  'fo',
  'fr',
  'ga',
  'gb',
  'gb-eng',
  'gb-nir',
  'gb-sct',
  'gb-wls',
  'gd',
  'ge',
  'gf',
  'gg',
  'gh',
  'gi',
  'gl',
  'gm',
  'gn',
  'gp',
  'gq',
  'gr',
  'gs',
  'gt',
  'gu',
  'gw',
  'gy',
  'hk',
  'hm',
  'hn',
  'hr',
  'ht',
  'hu',
  'ic',
  'id',
  'ie',
  'il',
  'im',
  'imperial',
  'in',
  'io',
  'iq',
  'ir',
  'is',
  'it',
  'je',
  'jm',
  'jo',
  'jolly',
  'jp',
  'ke',
  'kg',
  'kh',
  'ki',
  'km',
  'kn',
  'kp',
  'kr',
  'kw',
  'ky',
  'kz',
  'la',
  'lb',
  'lc',
  'li',
  'lk',
  'lr',
  'ls',
  'lt',
  'lu',
  'lv',
  'ly',
  'ma',
  'mc',
  'md',
  'me',
  'mf',
  'mg',
  'mh',
  'mk',
  'ml',
  'mm',
  'mn',
  'mo',
  'mp',
  'mq',
  'mr',
  'ms',
  'mt',
  'mu',
  'mv',
  'mw',
  'mx',
  'my',
  'mz',
  'na',
  'nc',
  'ne',
  'nf',
  'ng',
  'ni',
  'nl',
  'no',
  'np',
  'nr',
  'nu',
  'nz',
  'om',
  'pa',
  'pc',
  'pe',
  'pf',
  'pg',
  'ph',
  'pk',
  'pl',
  'pm',
  'pn',
  'pr',
  'ps',
  'pt',
  'pw',
  'py',
  'qa',
  'rainbow',
  're',
  'ro',
  'rs',
  'ru',
  'rw',
  'sa',
  'sb',
  'sc',
  'sd',
  'se',
  'sg',
  'sh',
  'sh-ac',
  'sh-hl',
  'sh-ta',
  'si',
  'sj',
  'sk',
  'sl',
  'sm',
  'sn',
  'so',
  'sr',
  'ss',
  'st',
  'sv',
  'sx',
  'sy',
  'sz',
  'tc',
  'td',
  'tf',
  'tg',
  'th',
  'tj',
  'tk',
  'tl',
  'tm',
  'tn',
  'to',
  'tr',
  'tt',
  'tv',
  'tw',
  'tz',
  'ua',
  'ug',
  'um',
  'un',
  'us',
  'uy',
  'uz',
  'va',
  'vc',
  've',
  'vg',
  'vi',
  'vn',
  'vu',
  'wf',
  'ws',
  'xk',
  'xx',
  'ye',
  'yt',
  'za',
  'zm',
  'zw',
] as const;

/** A flag the client can show */
export type FlagCode = (typeof FLAG_CODES)[number];

/** The flags the server accepts, from the protocol's id table */
export const SERVER_FLAG_CODES = [
  'ad',
  'ae',
  'al',
  'am',
  'aq',
  'ar',
  'at',
  'au',
  'az',
  'ba',
  'bd',
  'be',
  'bg',
  'bh',
  'bo',
  'br',
  'bt',
  'by',
  'ca',
  'ch',
  'cl',
  'cn',
  'co',
  'communist',
  'confederate',
  'cr',
  'cu',
  'cy',
  'cz',
  'de',
  'dk',
  'do',
  'dz',
  'ec',
  'ee',
  'eg',
  'es',
  'eu',
  'fi',
  'fr',
  'gb',
  'ge',
  'gr',
  'gt',
  'hk',
  'hn',
  'hr',
  'hu',
  'id',
  'ie',
  'il',
  'im',
  'imperial',
  'in',
  'iq',
  'ir',
  'is',
  'it',
  'jm',
  'jo',
  'jolly',
  'jp',
  'kp',
  'kr',
  'kw',
  'kz',
  'lb',
  'li',
  'lk',
  'lt',
  'lu',
  'lv',
  'ly',
  'ma',
  'mc',
  'md',
  'me',
  'mk',
  'mo',
  'mt',
  'mx',
  'my',
  'ng',
  'nl',
  'no',
  'np',
  'nz',
  'om',
  'pa',
  'pe',
  'ph',
  'pk',
  'pl',
  'pr',
  'pt',
  'py',
  'qa',
  'rainbow',
  'ro',
  'rs',
  'ru',
  'sa',
  'se',
  'sg',
  'si',
  'sk',
  'sm',
  'so',
  'sv',
  'sy',
  'th',
  'tm',
  'tn',
  'tr',
  'tt',
  'tw',
  'tz',
  'ua',
  'un',
  'us',
  'uy',
  'uz',
  've',
  'vn',
  'za',
] as const;

/** A flag the server accepts */
export type ServerFlagCode = (typeof SERVER_FLAG_CODES)[number];

/** A flag the client shows but the server does not accept yet */
export type ExtendedFlagCode = Exclude<FlagCode, ServerFlagCode>;

/** Display names: flag-icons' for its flags, the original client's for the custom five */
export const FLAG_NAMES: Readonly<Record<FlagCode, string>> = {
  ad: 'Andorra',
  ae: 'United Arab Emirates',
  af: 'Afghanistan',
  ag: 'Antigua and Barbuda',
  ai: 'Anguilla',
  al: 'Albania',
  am: 'Armenia',
  ao: 'Angola',
  aq: 'Antarctica',
  ar: 'Argentina',
  arab: 'League of Arab States',
  as: 'American Samoa',
  asean: 'Association of Southeast Asian Nations',
  at: 'Austria',
  au: 'Australia',
  aw: 'Aruba',
  ax: 'Aland Islands',
  az: 'Azerbaijan',
  ba: 'Bosnia and Herzegovina',
  bb: 'Barbados',
  bd: 'Bangladesh',
  be: 'Belgium',
  bf: 'Burkina Faso',
  bg: 'Bulgaria',
  bh: 'Bahrain',
  bi: 'Burundi',
  bj: 'Benin',
  bl: 'Saint Barthélemy',
  bm: 'Bermuda',
  bn: 'Brunei Darussalam',
  bo: 'Bolivia',
  bq: 'Bonaire, Sint Eustatius and Saba',
  br: 'Brazil',
  bs: 'Bahamas',
  bt: 'Bhutan',
  bv: 'Bouvet Island',
  bw: 'Botswana',
  by: 'Belarus',
  bz: 'Belize',
  ca: 'Canada',
  cc: 'Cocos (Keeling) Islands',
  cd: 'Democratic Republic of the Congo',
  cefta: 'Central European Free Trade Agreement',
  cf: 'Central African Republic',
  cg: 'Republic of the Congo',
  ch: 'Switzerland',
  ci: "Côte d'Ivoire",
  ck: 'Cook Islands',
  cl: 'Chile',
  cm: 'Cameroon',
  cn: 'China',
  co: 'Colombia',
  communist: 'Communist',
  confederate: 'Confederate',
  cp: 'Clipperton Island',
  cr: 'Costa Rica',
  cu: 'Cuba',
  cv: 'Cabo Verde',
  cw: 'Curaçao',
  cx: 'Christmas Island',
  cy: 'Cyprus',
  cz: 'Czech Republic',
  de: 'Germany',
  dg: 'Diego Garcia',
  dj: 'Djibouti',
  dk: 'Denmark',
  dm: 'Dominica',
  do: 'Dominican Republic',
  dz: 'Algeria',
  eac: 'East African Community',
  ec: 'Ecuador',
  ee: 'Estonia',
  eg: 'Egypt',
  eh: 'Western Sahara',
  er: 'Eritrea',
  es: 'Spain',
  'es-ct': 'Catalonia',
  'es-ga': 'Galicia',
  'es-pv': 'Basque Country',
  et: 'Ethiopia',
  eu: 'European Union',
  fi: 'Finland',
  fj: 'Fiji',
  fk: 'Falkland Islands',
  fm: 'Federated States of Micronesia',
  fo: 'Faroe Islands',
  fr: 'France',
  ga: 'Gabon',
  gb: 'United Kingdom',
  'gb-eng': 'England',
  'gb-nir': 'Northern Ireland',
  'gb-sct': 'Scotland',
  'gb-wls': 'Wales',
  gd: 'Grenada',
  ge: 'Georgia',
  gf: 'French Guiana',
  gg: 'Guernsey',
  gh: 'Ghana',
  gi: 'Gibraltar',
  gl: 'Greenland',
  gm: 'Gambia',
  gn: 'Guinea',
  gp: 'Guadeloupe',
  gq: 'Equatorial Guinea',
  gr: 'Greece',
  gs: 'South Georgia and the South Sandwich Islands',
  gt: 'Guatemala',
  gu: 'Guam',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  hk: 'Hong Kong',
  hm: 'Heard Island and McDonald Islands',
  hn: 'Honduras',
  hr: 'Croatia',
  ht: 'Haiti',
  hu: 'Hungary',
  ic: 'Canary Islands',
  id: 'Indonesia',
  ie: 'Ireland',
  il: 'Israel',
  im: 'Isle of Man',
  imperial: 'Imperial Japan',
  in: 'India',
  io: 'British Indian Ocean Territory',
  iq: 'Iraq',
  ir: 'Iran',
  is: 'Iceland',
  it: 'Italy',
  je: 'Jersey',
  jm: 'Jamaica',
  jo: 'Jordan',
  jolly: 'Jolly Roger',
  jp: 'Japan',
  ke: 'Kenya',
  kg: 'Kyrgyzstan',
  kh: 'Cambodia',
  ki: 'Kiribati',
  km: 'Comoros',
  kn: 'Saint Kitts and Nevis',
  kp: 'North Korea',
  kr: 'South Korea',
  kw: 'Kuwait',
  ky: 'Cayman Islands',
  kz: 'Kazakhstan',
  la: 'Laos',
  lb: 'Lebanon',
  lc: 'Saint Lucia',
  li: 'Liechtenstein',
  lk: 'Sri Lanka',
  lr: 'Liberia',
  ls: 'Lesotho',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  lv: 'Latvia',
  ly: 'Libya',
  ma: 'Morocco',
  mc: 'Monaco',
  md: 'Moldova',
  me: 'Montenegro',
  mf: 'Saint Martin',
  mg: 'Madagascar',
  mh: 'Marshall Islands',
  mk: 'North Macedonia',
  ml: 'Mali',
  mm: 'Myanmar',
  mn: 'Mongolia',
  mo: 'Macau',
  mp: 'Northern Mariana Islands',
  mq: 'Martinique',
  mr: 'Mauritania',
  ms: 'Montserrat',
  mt: 'Malta',
  mu: 'Mauritius',
  mv: 'Maldives',
  mw: 'Malawi',
  mx: 'Mexico',
  my: 'Malaysia',
  mz: 'Mozambique',
  na: 'Namibia',
  nc: 'New Caledonia',
  ne: 'Niger',
  nf: 'Norfolk Island',
  ng: 'Nigeria',
  ni: 'Nicaragua',
  nl: 'Netherlands',
  no: 'Norway',
  np: 'Nepal',
  nr: 'Nauru',
  nu: 'Niue',
  nz: 'New Zealand',
  om: 'Oman',
  pa: 'Panama',
  pc: 'Pacific Community',
  pe: 'Peru',
  pf: 'French Polynesia',
  pg: 'Papua New Guinea',
  ph: 'Philippines',
  pk: 'Pakistan',
  pl: 'Poland',
  pm: 'Saint Pierre and Miquelon',
  pn: 'Pitcairn',
  pr: 'Puerto Rico',
  ps: 'State of Palestine',
  pt: 'Portugal',
  pw: 'Palau',
  py: 'Paraguay',
  qa: 'Qatar',
  rainbow: 'Rainbow',
  re: 'Réunion',
  ro: 'Romania',
  rs: 'Serbia',
  ru: 'Russia',
  rw: 'Rwanda',
  sa: 'Saudi Arabia',
  sb: 'Solomon Islands',
  sc: 'Seychelles',
  sd: 'Sudan',
  se: 'Sweden',
  sg: 'Singapore',
  sh: 'Saint Helena, Ascension and Tristan da Cunha',
  'sh-ac': 'Ascension Island',
  'sh-hl': 'Saint Helena',
  'sh-ta': 'Tristan da Cunha',
  si: 'Slovenia',
  sj: 'Svalbard and Jan Mayen',
  sk: 'Slovakia',
  sl: 'Sierra Leone',
  sm: 'San Marino',
  sn: 'Senegal',
  so: 'Somalia',
  sr: 'Suriname',
  ss: 'South Sudan',
  st: 'Sao Tome and Principe',
  sv: 'El Salvador',
  sx: 'Sint Maarten',
  sy: 'Syria',
  sz: 'Eswatini',
  tc: 'Turks and Caicos Islands',
  td: 'Chad',
  tf: 'French Southern Territories',
  tg: 'Togo',
  th: 'Thailand',
  tj: 'Tajikistan',
  tk: 'Tokelau',
  tl: 'Timor-Leste',
  tm: 'Turkmenistan',
  tn: 'Tunisia',
  to: 'Tonga',
  tr: 'Türkiye',
  tt: 'Trinidad and Tobago',
  tv: 'Tuvalu',
  tw: 'Taiwan',
  tz: 'Tanzania',
  ua: 'Ukraine',
  ug: 'Uganda',
  um: 'United States Minor Outlying Islands',
  un: 'United Nations',
  us: 'United States of America',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  va: 'Holy See',
  vc: 'Saint Vincent and the Grenadines',
  ve: 'Venezuela',
  vg: 'Virgin Islands (British)',
  vi: 'Virgin Islands (U.S.)',
  vn: 'Vietnam',
  vu: 'Vanuatu',
  wf: 'Wallis and Futuna',
  ws: 'Samoa',
  xk: 'Kosovo',
  xx: 'Unknown',
  ye: 'Yemen',
  yt: 'Mayotte',
  za: 'South Africa',
  zm: 'Zambia',
  zw: 'Zimbabwe',
};
